var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.codes.entries()),function(ref){
var index = ref[0];
var c = ref[1];
return _c('span',{key:index,class:_vm.generateStyle(c.s)},[_vm._v(_vm._s(c.t))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }